import React, { useState } from 'react';
import { X, Plus, Zap, FileText, User, Sparkles, Search, CheckCircle, Clock, Lock, Eye, Send, Star, Users, Layers, TrendingUp, CalendarDays } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
interface AutoServiceDetailProps {
  activeAutoService: string;
  setActiveAutoService: (service: string | null) => void;
  showToast: (msg: string) => void;
}
export function AutoServiceDetail({
  activeAutoService,
  setActiveAutoService,
  showToast
}: AutoServiceDetailProps) {
  const [autoServiceTab, setAutoServiceTab] = useState<'create' | 'archive'>('archive');
  const autoServicesData: Record<string, {
    title: string;
    icon: any;
    color: string;
    total: number;
    used: number;
    active: boolean;
    reports: Array<{
      id: number;
      client: string;
      date: string;
      status: 'ready' | 'processing' | 'locked';
      birthDate: string;
      city: string;
    }>;
  }> = {
    natal: {
      title: 'Натальная карта',
      icon: FileText,
      color: 'indigo',
      total: 1000,
      used: 153,
      active: true,
      reports: [{
        id: 1,
        client: 'Мария Волкова',
        date: '15 Окт 2024',
        status: 'ready',
        birthDate: '12.03.1990',
        city: 'Москва'
      }, {
        id: 2,
        client: 'Дмитрий Романов',
        date: '14 Окт 2024',
        status: 'ready',
        birthDate: '05.07.1985',
        city: 'Санкт-Петербург'
      }, {
        id: 3,
        client: 'Анна Козлова',
        date: '13 Окт 2024',
        status: 'processing',
        birthDate: '22.11.1992',
        city: 'Казань'
      }, {
        id: 4,
        client: 'Ольга Петрова',
        date: '10 Окт 2024',
        status: 'ready',
        birthDate: '01.06.1988',
        city: 'Новосибирск'
      }, {
        id: 5,
        client: 'Иван Сидоров',
        date: '08 Окт 2024',
        status: 'ready',
        birthDate: '15.09.1995',
        city: 'Екатеринбург'
      }, {
        id: 6,
        client: 'Елена Тимофеева',
        date: '25 Сен 2024',
        status: 'ready',
        birthDate: '30.01.1987',
        city: 'Краснодар'
      }, {
        id: 7,
        client: 'Павел Морозов',
        date: '22 Сен 2024',
        status: 'ready',
        birthDate: '18.04.1991',
        city: 'Самара'
      }]
    },
    solar: {
      title: 'Соляр (Прогноз на год)',
      icon: Star,
      color: 'amber',
      total: 500,
      used: 47,
      active: true,
      reports: [{
        id: 1,
        client: 'Мария Волкова',
        date: '14 Окт 2024',
        status: 'ready',
        birthDate: '12.03.1990',
        city: 'Москва'
      }, {
        id: 2,
        client: 'Анна Козлова',
        date: '12 Окт 2024',
        status: 'ready',
        birthDate: '22.11.1992',
        city: 'Казань'
      }, {
        id: 3,
        client: 'Светлана Иванова',
        date: '05 Окт 2024',
        status: 'ready',
        birthDate: '08.12.1989',
        city: 'Ростов-на-Дону'
      }]
    },
    synastry: {
      title: 'Синастрия (Совместимость)',
      icon: Users,
      color: 'rose',
      total: 200,
      used: 89,
      active: true,
      reports: [{
        id: 1,
        client: 'Мария + Дмитрий',
        date: '15 Окт 2024',
        status: 'ready',
        birthDate: '12.03.1990 / 05.07.1985',
        city: 'Москва'
      }, {
        id: 2,
        client: 'Анна + Павел',
        date: '11 Окт 2024',
        status: 'ready',
        birthDate: '22.11.1992 / 18.04.1991',
        city: 'Казань'
      }]
    },
    combo: {
      title: 'Комбо (Натал + Соляр)',
      icon: Layers,
      color: 'emerald',
      total: 0,
      used: 0,
      active: false,
      reports: []
    },
    forecast: {
      title: 'Транзиты (Прогноз)',
      icon: TrendingUp,
      color: 'sky',
      total: 0,
      used: 0,
      active: false,
      reports: []
    },
    calendar: {
      title: 'Астро-календарь',
      icon: CalendarDays,
      color: 'purple',
      total: 0,
      used: 0,
      active: false,
      reports: []
    }
  };
  const svc = autoServicesData[activeAutoService];
  if (!svc) return null;
  const remaining = svc.total - svc.used;
  const ServiceIcon = svc.icon;
  return <div className="space-y-6" data-id="element-12294">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-12295">
        <div className="flex items-center gap-3" data-id="element-12296">
          <button onClick={() => {
          setActiveAutoService(null);
          setAutoServiceTab('archive');
        }} className="p-2 hover:bg-slate-100 rounded-full transition-colors -ml-2" data-id="element-12297">
            <X className="w-5 h-5 text-slate-500" data-id="element-12298" />
          </button>
          <div className={`w-10 h-10 rounded-xl bg-${svc.color}-100 flex items-center justify-center`} data-id="element-12299">
            <ServiceIcon className={`w-5 h-5 text-${svc.color}-600`} data-id="element-12300" />
          </div>
          <div data-id="element-12301">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-12302">{svc.title}</h2>
            <div className="text-xs text-slate-500" data-id="element-12303">Авто-генерация отчётов</div>
          </div>
        </div>
        {svc.active ? <div className="flex items-center gap-3" data-id="element-12304">
            <div className="text-right" data-id="element-12305">
              <div className="text-xs text-slate-500" data-id="element-12306">Остаток</div>
              <div className="text-lg font-bold text-slate-900" data-id="element-12307">
                {remaining}{' '}
                <span className="text-xs text-slate-400 font-normal" data-id="element-12308">
                  / {svc.total}
                </span>
              </div>
            </div>
            <Button variant="outline" size="sm" icon={<Plus className="w-3.5 h-3.5" data-id="element-12310" />} onClick={() => showToast('Пакет генераций добавлен в корзину — 500 генераций за 990 ₽')} data-id="element-12309">
              Докупить
            </Button>
          </div> : <Button variant="primary" size="sm" icon={<Zap className="w-3.5 h-3.5" data-id="element-12312" />} onClick={() => showToast('Услуга подключена! Стартовый пакет: 100 генераций бесплатно')} data-id="element-12311">
            Подключить услугу
          </Button>}
      </div>

      {/* Balance bar */}
      {svc.active && <Card padding="sm" className="bg-slate-50 border-slate-100" data-id="element-12313">
          <div className="flex items-center justify-between text-xs mb-1.5 px-1" data-id="element-12314">
            <span className="text-slate-600" data-id="element-12315">
              Использовано:{' '}
              <span className="font-semibold text-slate-800" data-id="element-12316">{svc.used}</span>{' '}
              из {svc.total}
            </span>
            <span className={`font-medium ${remaining < svc.total * 0.15 ? 'text-rose-500' : 'text-emerald-600'}`} data-id="element-12317">
              {remaining < svc.total * 0.15 ? 'Заканчивается!' : `${Math.round((1 - svc.used / svc.total) * 100)}% свободно`}
            </span>
          </div>
          <div className="w-full bg-slate-200 rounded-full h-2 px-0" data-id="element-12318">
            <div className={`h-2 rounded-full transition-all ${remaining < svc.total * 0.15 ? 'bg-rose-500' : svc.used / svc.total > 0.5 ? 'bg-amber-500' : 'bg-emerald-500'}`} style={{
          width: `${svc.used / svc.total * 100}%`
        }} data-id="element-12319" />
          </div>
        </Card>}

      {/* Tabs: Create / Archive */}
      {svc.active && <div className="flex gap-1 bg-white p-1 rounded-xl border border-slate-100 shadow-sm w-fit" data-id="element-12320">
          <button onClick={() => setAutoServiceTab('create')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${autoServiceTab === 'create' ? 'bg-indigo-50 text-primary' : 'text-slate-600 hover:bg-slate-50'}`} data-id="element-12321">
            <span className="flex items-center gap-1.5" data-id="element-12322">
              <Plus className="w-4 h-4" data-id="element-12323" /> Создать отчёт
            </span>
          </button>
          <button onClick={() => setAutoServiceTab('archive')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${autoServiceTab === 'archive' ? 'bg-indigo-50 text-primary' : 'text-slate-600 hover:bg-slate-50'}`} data-id="element-12324">
            <span className="flex items-center gap-1.5" data-id="element-12325">
              <FileText className="w-4 h-4" data-id="element-12326" /> Архив отчётов
              <span className="text-[10px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded-full" data-id="element-12327">
                {svc.reports.length}
              </span>
            </span>
          </button>
        </div>}

      {/* Create Report Form */}
      {svc.active && autoServiceTab === 'create' && <Card padding="lg" data-id="element-12328">
          <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-12329">
            Создать новый отчёт
          </h3>
          <p className="text-sm text-slate-500 mb-6" data-id="element-12330">
            Введите данные клиента — отчёт будет сгенерирован автоматически и
            появится в архиве.
          </p>

          <form className="space-y-5" data-id="element-12331">
            {activeAutoService === 'synastry' ? <>
                <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-12332">
                  <div className="text-sm font-bold text-slate-700 mb-3 flex items-center gap-2" data-id="element-12333">
                    <User className="w-4 h-4 text-slate-500" data-id="element-12334" /> Первый партнёр
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12335">
                    <Input label="Имя" placeholder="Имя клиента" data-id="element-12336" />
                    <Input label="Дата рождения" type="date" data-id="element-12337" />
                    <Input label="Время рождения" type="time" data-id="element-12338" />
                    <Input label="Город рождения" placeholder="Москва" data-id="element-12339" />
                  </div>
                </div>
                <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-12340">
                  <div className="text-sm font-bold text-slate-700 mb-3 flex items-center gap-2" data-id="element-12341">
                    <User className="w-4 h-4 text-slate-500" data-id="element-12342" /> Второй партнёр
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12343">
                    <Input label="Имя" placeholder="Имя партнёра" data-id="element-12344" />
                    <Input label="Дата рождения" type="date" data-id="element-12345" />
                    <Input label="Время рождения" type="time" data-id="element-12346" />
                    <Input label="Город рождения" placeholder="Москва" data-id="element-12347" />
                  </div>
                </div>
              </> : <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12348">
                <Input label="Имя клиента" placeholder="Имя" data-id="element-12349" />
                <Input label="Дата рождения" type="date" data-id="element-12350" />
                <Input label="Время рождения" type="time" data-id="element-12351" />
                <Input label="Город рождения" placeholder="Москва" data-id="element-12352" />
                {(activeAutoService === 'solar' || activeAutoService === 'combo') && <>
                    <Input label="Год прогноза" type="number" placeholder="2025" defaultValue="2025" data-id="element-12353" />
                    <Input label="Город встречи соляра" placeholder="Где будет в день рождения" data-id="element-12354" />
                  </>}
              </div>}

            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pt-4 border-t border-slate-100" data-id="element-12355">
              <div className="text-xs text-slate-500 flex items-center gap-1.5" data-id="element-12356">
                <Zap className="w-3.5 h-3.5 text-amber-500" data-id="element-12357" />
                Будет списана{' '}
                <span className="font-bold text-slate-700" data-id="element-12358">1 единица</span> из
                баланса ({remaining} осталось)
              </div>
              <Button variant="primary" icon={<Sparkles className="w-4 h-4" data-id="element-12360" />} onClick={() => {
            showToast('Отчёт генерируется... Появится в архиве через 1-2 минуты ✓');
            setAutoServiceTab('archive');
          }} data-id="element-12359">
                Сгенерировать отчёт
              </Button>
            </div>
          </form>
        </Card>}

      {/* Archive */}
      {svc.active && autoServiceTab === 'archive' && <div className="space-y-3" data-id="element-12361">
          {svc.reports.length === 0 ? <Card padding="lg" className="text-center py-16" data-id="element-12362">
              <FileText className="w-12 h-12 text-slate-300 mx-auto mb-4" data-id="element-12363" />
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-12364">Нет отчётов</h3>
              <p className="text-sm text-slate-500 mb-4" data-id="element-12365">
                Создайте первый отчёт — он появится здесь
              </p>
              <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-12367" />} onClick={() => setAutoServiceTab('create')} data-id="element-12366">
                Создать отчёт
              </Button>
            </Card> : <>
              {/* Search */}
              <div className="relative w-full sm:w-72" data-id="element-12368">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-12369">
                  <Search className="h-4 w-4 text-slate-400" data-id="element-12370" />
                </div>
                <input type="text" placeholder="Поиск по имени клиента..." className="block w-full pl-10 pr-3 py-2 border border-slate-200 rounded-xl text-sm bg-white placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition-colors" data-id="element-12371" />
              </div>

              {/* Reports list */}
              {svc.reports.map(report => <Card key={report.id} padding="sm" className={`transition-all ${report.status === 'locked' ? 'opacity-60 bg-slate-50' : ''}`} data-id="element-12372">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-3 py-2" data-id="element-12373">
                    <div className="flex items-center gap-3 min-w-0" data-id="element-12374">
                      <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${report.status === 'ready' ? 'bg-emerald-100' : report.status === 'processing' ? 'bg-amber-100' : 'bg-slate-100'}`} data-id="element-12375">
                        {report.status === 'ready' ? <CheckCircle className="w-4.5 h-4.5 text-emerald-600" data-id="element-12376" /> : report.status === 'processing' ? <Clock className="w-4.5 h-4.5 text-amber-600" data-id="element-12377" /> : <Lock className="w-4.5 h-4.5 text-slate-400" data-id="element-12378" />}
                      </div>
                      <div className="min-w-0" data-id="element-12379">
                        <div className="flex items-center gap-2 mb-0.5" data-id="element-12380">
                          <span className="text-sm font-bold text-slate-900 truncate" data-id="element-12381">
                            {report.client}
                          </span>
                          <Badge variant={report.status === 'ready' ? 'success' : report.status === 'processing' ? 'warning' : 'neutral'} size="sm" data-id="element-12382">
                            {report.status === 'ready' ? 'Готов' : report.status === 'processing' ? 'Генерация...' : 'Заблокирован'}
                          </Badge>
                        </div>
                        <div className="text-[11px] text-slate-500" data-id="element-12383">
                          {report.date} • Рождение: {report.birthDate} •{' '}
                          {report.city}
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center gap-2 flex-shrink-0" data-id="element-12384">
                      {report.status === 'ready' && <>
                          <Button variant="outline" size="sm" className="text-xs px-2.5 py-1 h-auto" icon={<Eye className="w-3.5 h-3.5" data-id="element-12386" />} onClick={() => showToast('Открытие отчёта...')} data-id="element-12385">
                            Открыть
                          </Button>
                          <Button variant="outline" size="sm" className="text-xs px-2.5 py-1 h-auto" icon={<FileText className="w-3.5 h-3.5" data-id="element-12388" />} onClick={() => showToast('Печать на фирменном бланке...')} data-id="element-12387">
                            Печать
                          </Button>
                          <Button variant="outline" size="sm" className="text-xs px-2.5 py-1 h-auto" icon={<Send className="w-3.5 h-3.5" data-id="element-12390" />} onClick={() => showToast('Отчёт отправлен клиенту ✓')} data-id="element-12389">
                            Отправить
                          </Button>
                        </>}
                      {report.status === 'processing' && <span className="text-xs text-amber-600 font-medium flex items-center gap-1" data-id="element-12391">
                          <Clock className="w-3.5 h-3.5 animate-pulse" data-id="element-12392" /> ~2 мин
                        </span>}
                      {report.status === 'locked' && <Button variant="primary" size="sm" className="text-xs px-3 py-1 h-auto" icon={<Lock className="w-3.5 h-3.5" data-id="element-12394" />} onClick={() => showToast('Отчёт разблокирован — списано 50 генераций')} data-id="element-12393">
                          Разблокировать
                        </Button>}
                    </div>
                  </div>
                </Card>)}
            </>}
        </div>}

      {/* Inactive service state */}
      {!svc.active && <Card padding="lg" className="text-center py-16" data-id="element-12395">
          <div className={`w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-4`} data-id="element-12396">
            <ServiceIcon className="w-8 h-8 text-slate-400" data-id="element-12397" />
          </div>
          <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-12398">
            Услуга не подключена
          </h3>
          <p className="text-sm text-slate-500 mb-6 max-w-md mx-auto" data-id="element-12399">
            Подключите «{svc.title}» чтобы автоматически генерировать отчёты для
            клиентов. Купите пакет или отдельные единицы.
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-12400">
            <button onClick={() => showToast('1 шт добавлена ✓')} className="text-sm font-medium px-4 py-2 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-12401">
              Купить 1 шт
            </button>
            <button onClick={() => showToast('Пакет 100 шт оплачен ✓')} className="text-sm font-medium px-4 py-2 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors" data-id="element-12402">
              100 шт <span className="text-xs text-indigo-400" data-id="element-12403">-30%</span>
            </button>
            <button onClick={() => showToast('Пакет 500 шт оплачен ✓')} className="text-sm font-medium px-4 py-2 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors" data-id="element-12404">
              500 шт <span className="text-xs text-indigo-400" data-id="element-12405">-40%</span>
            </button>
            <button onClick={() => showToast('Пакет 1000 шт оплачен ✓')} className="text-sm font-medium px-4 py-2 rounded-lg border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 transition-colors" data-id="element-12406">
              1 000 шт <span className="text-xs text-amber-400" data-id="element-12407">-50%</span>
            </button>
          </div>
        </Card>}
    </div>;
}